module.exports = __webpack_public_path__ + "img/drive_charge.4f619ebb.svg";